/* eslint-disable no-redeclare */

import noop from 'lodash/noop';

const DEFAULT_DELAY_IN_MS = 500;

function getDelay(fnOrDelay?: (() => unknown) | number, delayInMs?: number): number {
  if (typeof delayInMs === 'number') {
    return delayInMs;
  }

  if (typeof fnOrDelay === 'number') {
    return fnOrDelay;
  }

  return DEFAULT_DELAY_IN_MS;
}

function getCallback<T>(fnOrDelay?: (() => T) | number): () => T {
  if (typeof fnOrDelay === 'function') {
    return fnOrDelay;
  }

  return noop as () => T;
}

function postpone(): Promise<void>;
function postpone(delayInMs: number): Promise<void>;
function postpone<T>(fn: () => T, delayInMs?: number): Promise<T>;
async function postpone<T>(fnOrDelay?: (() => T) | number, delayInMs?: number): Promise<T | void> {
  const delay = getDelay(fnOrDelay, delayInMs);
  const callback = getCallback(fnOrDelay);

  return new Promise((res) =>
    setTimeout(() => {
      res(callback());
    }, delay),
  );
}

function remit(): Promise<void>;
function remit(delayInMs: number): Promise<void>;
function remit<T>(fn: () => T, delayInMs?: number): Promise<T>;
async function remit<T>(fnOrDelay?: (() => T) | number, delayInMs?: number): Promise<T | void> {
  const delay = getDelay(fnOrDelay, delayInMs);
  const callback = getCallback(fnOrDelay);

  return new Promise((res, rej) =>
    setTimeout(() => {
      rej(callback());
    }, delay),
  );
}

export { postpone, remit };
